import { Box, CircularProgress } from '@mui/material';

export { CircularProgress } from '@mui/material';

interface Props {
  show: boolean;
}

export function Spinner({ show }: Props) {
  return show ? (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Box>
  ) : null;
}
